import React, { useContext } from "react";
import { EMPTY_VALUE_PLACEHOLDER } from "@sscs/utils";
import { IconButton, Table, Tooltip } from "../../";
import { ChevronDownIcon as KeyboardArrowDown, ChevronUpIcon as KeyboardArrowUp, } from "../../../icons";
import context from "./context";
import styles from "./expandedRow.module.scss";
const disabledLabel = "No details available";
const Summary = ({ children }) => {
    const { id, disabled, expanded, handleChange } = useContext(context);
    return (React.createElement(React.Fragment, null,
        React.createElement(Table.Cell, null, disabled ? (React.createElement(Tooltip, { title: disabledLabel },
            React.createElement("span", { className: styles["disabled-trigger"] },
                React.createElement(IconButton, { id: id, "aria-label": disabledLabel, size: "small", disabled: true }, EMPTY_VALUE_PLACEHOLDER)))) : (React.createElement(IconButton, { id: id, "aria-label": "expand row", size: "small", onClick: (event) => {
                if (expanded)
                    event.stopPropagation();
                handleChange(!expanded);
            } }, expanded ? (React.createElement(KeyboardArrowUp, { className: styles["expand-icon"] })) : (React.createElement(KeyboardArrowDown, { className: styles["expand-icon"] }))))),
        children));
};
export default Summary;
//# sourceMappingURL=Summary.js.map